@let obs =
  {
    categoryCarousel: categoryCarousel$ | async,
    isTabletMdUp: isTabletMdUp$ | async,
    numberOfSkeletons: numberOfSkeletons$ | async,
    isLoading: isLoading$ | async,
  };

@if (obs.isLoading) {
  <div class="skeleton-container container-v2 sd-group-skeleton-gradient-wave">
    @for (i of [].constructor(obs.numberOfSkeletons); track $index) {
      <div class="sd-skeleton"></div>
    }
  </div>
} @else if (obs.categoryCarousel && obs.categoryCarousel.length > 0) {
  <div class="container-v2 category-carousel-wrapper" [class.has-gradient]="!isAtEnd()" [class.no-gradient]="isAtEnd()">
    <sd-swiper
      [items]="obs.categoryCarousel"
      [config]="config"
      (reachEnd)="onReachEnd()"
      (fromEdge)="onFromEdge($event)"
    >
      <ng-template let-item="item">
        <div class="category-carousel-item">
          <a
            [routerLink]="item.link"
            class="link-black link-hover-orange link-hover-underlined text-b3-m-300 text-lg-b3-l-300"
          >
            @if (obs.isTabletMdUp) {
              {{ item.label }}
            } @else {
              <img [ngSrc]="item.url" [alt]="item.altText" fill />
            }
          </a>
        </div>
      </ng-template>
    </sd-swiper>
  </div>
}
